import React from 'react'
import PropTypes from 'prop-types'
/* --------------------------------------------- */
const FavouritesIcon = ({ color, ...rest }) => (
  <svg viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg' {...rest}>
    <g>
      <path
        stroke={color} d='m60.522428,35.860161c23.088528,-59.161081 113.550136,0 0,76.064247c-113.550136,-76.064247 -23.088528,-135.225327 0,-76.064247z'
        strokeWidth='6' fill='transparent'
      />
    </g>
  </svg>
)
/* --------------------------------------------- */
FavouritesIcon.propTypes = {
  /** Color of icon. */
  color: PropTypes.string,
  /** Icon css styles. */
  style: PropTypes.object
}
/* --------------------------------------------- */
FavouritesIcon.defaultProps = {
  color: 'transparent',
  style: {
    width: 25,
    height: 25
  }
}
/* --------------------------------------------- */
export default FavouritesIcon
/* --------------------------------------------- */
